import { HttpContextToken } from '@angular/common/http';

/**
 * Marca requisições de autenticação (sign-in / refresh) que NÃO devem
 * disparar o fluxo de refresh no interceptor em caso de 401 — evita loop.
 */
export const SKIP_AUTH_REFRESH = new HttpContextToken<boolean>(() => false);
